define('components/course/models/theme-manager',[
    'components/course/collections/themes',
    'components/course/models/theme',
    'components/course/radio-channel'
], function (Themes, Theme, channel) {
    "use strict";

    var ModuleEvent = channel.Event.Module,
        SlideEvent = channel.Event.Slide,
        ThemeEvent = channel.Event.Theme;

    return Backbone.Model.extend({
        "defaults": function () {
            return {
                "currentTheme": null,
                "themes": new Themes()
            };
        },

        "initialize": function () {
            this.initRadioComm();
        },

        "initRadioComm": function () {
            channel.comply(ThemeEvent.SET, this.setTheme, this)
                   .comply(ThemeEvent.CLEAR, this.clearTheme, this)

                   .reply(ThemeEvent.CURRENT, this.getCurrentTheme, this)

                   .on(SlideEvent.CHANGE, this.onSlideChange, this);
        },

        "destroy": function () {
            channel.stopReplying(ThemeEvent.CURRENT, this.getCurrentTheme, this)
                   .off(SlideEvent.CHANGE, this.onSlideChange, this);

            Backbone.Model.prototype.destroy.apply(this, arguments);
        },

        "getCurrentTheme": function () {
            return this.get('currentTheme');
        },

        "getTheme": function (sectionIndex, slideIndex) {
            var themes = this.get('themes'),
                selectedTheme;

            selectedTheme = themes.reduce(function (reducedVal, theme) {
                var curSectionIndex = theme.get('sectionIndex'),
                    curSlideIndex = theme.get('slideIndex'),
                    reducedValSectionIndex = null,
                    reducedValSlideIndex = null;

                if (curSectionIndex > sectionIndex
                    || curSectionIndex === sectionIndex && curSlideIndex > slideIndex) {
                    return reducedVal;
                }

                if (reducedVal) {
                    reducedValSectionIndex = reducedVal.get('sectionIndex');
                    reducedValSlideIndex = reducedVal.get('slideIndex');

                    if (curSectionIndex < reducedValSectionIndex
                        || curSectionIndex === reducedValSectionIndex && curSlideIndex < reducedValSlideIndex) {
                        return reducedVal;
                    }
                }

                reducedVal = theme;

                return reducedVal;
            }, null);

            return selectedTheme;
        },

        "getMetadata": function () {
            var module = channel.request(ModuleEvent.GET),
                sections = module.get('sections'),
                slides = sections.getActiveSection().get('slides');

            return {
                "sectionIndex": sections.getActiveSectionIndex(),
                "slideIndex": slides.getActiveSlideIndex()
            };
        },

        "onSlideChange": function () {
            var metadata = this.getMetadata(),
                oldTheme = this.get('currentTheme'),
                currentTheme;

            currentTheme = this.getTheme(
                                            metadata.sectionIndex,
                                            metadata.slideIndex
                                        );

            this.set('currentTheme', currentTheme);

            if (currentTheme !== oldTheme) {
                channel.trigger(ThemeEvent.UPDATE, currentTheme, oldTheme);
            }
        },

        "setTheme": function (newTheme) {
            var prevTheme = this.get('currentTheme'),
                themes = this.get('themes'),
                metadata = this.getMetadata(),
                existingTheme;

            existingTheme = themes.findWhere({
                "sectionIndex": metadata.sectionIndex,
                "slideIndex": metadata.slideIndex
            }) || null;

            if (existingTheme) {
                // We are replacing the theme
                themes.remove(existingTheme);
            }

            if (newTheme) {
                newTheme.set({
                    "sectionIndex": metadata.sectionIndex,
                    "slideIndex": metadata.slideIndex
                });
            }

            themes.add(newTheme);

            this.set('currentTheme', newTheme);
            channel.trigger(ThemeEvent.UPDATE, newTheme, prevTheme);
        },

        "clearTheme": function () {
            this.setTheme(null);
        }
    });
});

